/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Describes a calendar permission
 * @export
 */
export const CalendarSettingsPermissionEnum = {
    Admin: 'ADMIN',
    Access: 'ACCESS'
} as const;
export type CalendarSettingsPermissionEnum = typeof CalendarSettingsPermissionEnum[keyof typeof CalendarSettingsPermissionEnum];


export function instanceOfCalendarSettingsPermissionEnum(value: any): boolean {
    for (const key in CalendarSettingsPermissionEnum) {
        if (Object.prototype.hasOwnProperty.call(CalendarSettingsPermissionEnum, key)) {
            if (CalendarSettingsPermissionEnum[key as keyof typeof CalendarSettingsPermissionEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CalendarSettingsPermissionEnumFromJSON(json: any): CalendarSettingsPermissionEnum {
    return CalendarSettingsPermissionEnumFromJSONTyped(json, false);
}

export function CalendarSettingsPermissionEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalendarSettingsPermissionEnum {
    return json as CalendarSettingsPermissionEnum;
}

export function CalendarSettingsPermissionEnumToJSON(value?: CalendarSettingsPermissionEnum | null): any {
    return value as any;
}

export function CalendarSettingsPermissionEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): CalendarSettingsPermissionEnum {
    return value as CalendarSettingsPermissionEnum;
}

